// extracted by mini-css-extract-plugin
export var banner = "_ry-0";
export var settingRow = "_ry-2";
export var titleIcon = "_ry-1";